import { useMutation } from 'react-query'

import { APIError } from '../../../../utils'
import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { deleteQuote, deleteSalesDocumentDraft } from '../../query-api'

interface UseDeleteQuoteProps {
  documentType: InvoiceDocumentType
  onError?: (error?: APIError) => void
  onSuccess?: (data: void) => void
}

export const useDeleteQuote = (props: UseDeleteQuoteProps) => {
  const { documentType, onError, onSuccess } = props

  const { mutate, isLoading, ...rest } = useMutation(
    async (quoteId: number) => {
      if (documentType === InvoiceDocumentType.QuoteDraft) {
        await deleteSalesDocumentDraft({ documentId: quoteId, documentType: InvoiceDocumentType.Quote })
      } else {
        await deleteQuote(quoteId)
      }
    },
    { onSuccess, onError },
  )

  return { deleteQuote: mutate, isProcessing: isLoading, ...rest }
}
